import { useTabsContext } from ".";
import classNames from "classnames";

type TabProps = {
  value: string;
  name: string;
};

const Tab = ({ value, name }: TabProps) => {
  const { activeTab, setActiveTab } = useTabsContext();

  return (
    <div
      className={classNames(
        "w-full text-sm leading-[21px] font-normal text-center py-[11px] cursor-pointer",
        activeTab === value
          ? "text-secondary border-b-2 border-secondary font-medium"
          : "text-[#6B7280] border-b border-[#E5E7EB]"
      )}
      onClick={() => setActiveTab(value)}
    >
      {name}
    </div>
  );
};

export default Tab;
